// extracted by mini-css-extract-plugin
export default {"container":"UserDetails__container--1_f","title":"UserDetails__title--3yC","error":"UserDetails__error--3Pu","text":"UserDetails__text--1zA","button":"UserDetails__button--3WC"};